import React from 'react'
import avatar from './avatar.png'

interface AvatarProps {
  className?: string
  size?: number
  color?: string
  background?: string
}

const Avatar: React.FC<AvatarProps> = ({ className = '', size = 48 }) => {
  return <img src={avatar} alt="avatar" width={size} height={size} className={className} />
}

export default Avatar
